// import axios from 'axios';

// const API_BASE = '/api';

// export interface GlobalSchedule {
//   frequency: string;
//   day_of_week: number;
//   day_of_month: number;
//   time: string;
//   is_active: number;
// }

// export interface VendorSchedule {
//   id: string;
//   vendor_id: string;
//   frequency: string;
//   day_of_week: number | null;
//   day_of_month: number | null;
//   time: string;
//   is_active: number;
//   last_run: string | null;
//   next_run: string | null;
// }

// export interface AlertRule {
//   id: string;
//   name: string;
//   type: string;
//   vendor_id: string | null;
//   threshold_value: number | null;
//   threshold_percentage: number | null;
//   consecutive_count: number;
//   cooldown_minutes: number;
//   severity: string;
//   is_active: number;
//   time_start: string | null;
//   time_end: string | null;
//   days_of_week: string | null;
//   escalation_minutes: number | null;
//   escalation_severity: string | null;
//   webhook_url: string | null;
// }

// export interface Alert {
//   id: string;
//   vendor_id: string;
//   vendor_name: string;
//   alert_type: string;
//   message: string;
//   severity: string;
//   old_value: string | null;
//   new_value: string | null;
//   is_read: number;
//   created_at: string;
// }

// export interface DriftSettings {
//   score_threshold: number;
//   risk_level_drift: number;
//   compliance_drop_percentage: number;
//   is_active: number;
// }

// export interface MonitoringStats {
//   total_alerts: number;
//   unread_alerts: number;
//   active_schedules: number;
//   active_rules: number;
//   active_silences: number;
//   severity_breakdown: Record<string, number>;
//   daily_trend: Array<{ date: string; count: number }>;
// }

// const monitoringApi = {
//   // Schedule endpoints
//   getGlobalSchedule: () => axios.get(`${API_BASE}/v1/monitoring/schedule/global`),
//   updateGlobalSchedule: (data: GlobalSchedule) => axios.put(`${API_BASE}/v1/monitoring/schedule/global`, data),
//   getVendorSchedule: (vendorId: string) => axios.get(`${API_BASE}/v1/monitoring/schedule/vendor/${vendorId}`),
//   createVendorSchedule: (data: any) => axios.post(`${API_BASE}/v1/monitoring/schedule/vendor`, data),
//   getAllSchedules: () => axios.get(`${API_BASE}/v1/monitoring/schedule/all`),
//   bulkUpdateSchedules: (data: any) => axios.post(`${API_BASE}/v1/monitoring/schedule/bulk`, data),
  
//   // Alert Rules
//   getAlertRules: (vendorId?: string) => axios.get(`${API_BASE}/v1/monitoring/alerts/rules`, { params: { vendor_id: vendorId } }),
//   getAlertRule: (ruleId: string) => axios.get(`${API_BASE}/v1/monitoring/alerts/rules/${ruleId}`),
//   createAlertRule: (data: any) => axios.post(`${API_BASE}/v1/monitoring/alerts/rules`, data),
//   updateAlertRule: (ruleId: string, data: any) => axios.put(`${API_BASE}/v1/monitoring/alerts/rules/${ruleId}`, data),
//   deleteAlertRule: (ruleId: string) => axios.delete(`${API_BASE}/v1/monitoring/alerts/rules/${ruleId}`),
  
//   // Alert History
//   getUnreadAlerts: (vendorId?: string) => axios.get(`${API_BASE}/v1/monitoring/alerts/unread`, { params: { vendor_id: vendorId } }),
//   getAlertHistory: (vendorId?: string, limit?: number, offset?: number) => 
//     axios.get(`${API_BASE}/v1/monitoring/alerts/history`, { params: { vendor_id: vendorId, limit, offset } }),
//   getAlertStatistics: () => axios.get(`${API_BASE}/v1/monitoring/alerts/statistics`),
//   markAlertRead: (alertId: string) => axios.post(`${API_BASE}/v1/monitoring/alerts/${alertId}/read`),
//   bulkMarkRead: (alertIds: string[]) => axios.post(`${API_BASE}/v1/monitoring/alerts/bulk-read`, alertIds),
//   acknowledgeAlert: (alertId: string, acknowledgedBy: string) => 
//     axios.post(`${API_BASE}/v1/monitoring/alerts/${alertId}/acknowledge`, null, { params: { acknowledged_by: acknowledgedBy } }),
//   resolveAlert: (alertId: string, resolutionNote?: string) => 
//     axios.post(`${API_BASE}/v1/monitoring/alerts/${alertId}/resolve`, { resolution_note: resolutionNote }),
//   exportAlerts: () => axios.get(`${API_BASE}/v1/monitoring/export/alerts`),
  
//   // Indicator Groups
//   getIndicatorGroups: () => axios.get(`${API_BASE}/v1/monitoring/indicator-groups`),
//   getVendorIndicatorGroups: (vendorId: string) => axios.get(`${API_BASE}/v1/monitoring/indicator-groups/vendor/${vendorId}`),
//   updateVendorIndicatorGroups: (vendorId: string, data: any) => 
//     axios.put(`${API_BASE}/v1/monitoring/indicator-groups/vendor/${vendorId}`, data),
//   getAllVendorIndicatorSelections: () => axios.get(`${API_BASE}/v1/monitoring/indicator-groups/all-vendors`),
//   bulkUpdateIndicatorGroups: (data: any) => axios.post(`${API_BASE}/v1/monitoring/indicator-groups/bulk`, data),
  
//   // Alert Silences
//   getActiveSilences: (vendorId?: string, ruleId?: string) => 
//     axios.get(`${API_BASE}/v1/monitoring/silences`, { params: { vendor_id: vendorId, rule_id: ruleId } }),
//   createAlertSilence: (data: any) => axios.post(`${API_BASE}/v1/monitoring/silences`, data),
//   deactivateSilence: (silenceId: string) => axios.delete(`${API_BASE}/v1/monitoring/silences/${silenceId}`),
  
//   // Notification Channels
//   getNotificationChannels: () => axios.get(`${API_BASE}/v1/monitoring/channels`),
//   createNotificationChannel: (data: any) => axios.post(`${API_BASE}/v1/monitoring/channels`, data),
//   updateNotificationChannel: (channelId: string, config: any) => 
//     axios.put(`${API_BASE}/v1/monitoring/channels/${channelId}`, config),
//   deleteNotificationChannel: (channelId: string) => axios.delete(`${API_BASE}/v1/monitoring/channels/${channelId}`),
//   addRuleChannelMapping: (ruleId: string, data: any) => 
//     axios.post(`${API_BASE}/v1/monitoring/rules/${ruleId}/channels`, data),
//   getRuleChannels: (ruleId: string) => axios.get(`${API_BASE}/v1/monitoring/rules/${ruleId}/channels`),
  
//   // Drift Settings
//   getDriftSettings: (vendorId: string) => axios.get(`${API_BASE}/v1/monitoring/drift/${vendorId}`),
//   updateDriftSettings: (vendorId: string, data: DriftSettings) => 
//     axios.put(`${API_BASE}/v1/monitoring/drift/${vendorId}`, data),
  
//   // Monitoring Stats
//   getMonitoringStats: () => axios.get(`${API_BASE}/v1/monitoring/stats`),
  
//   // Manual Check
//   triggerManualCheck: (vendorId: string) => axios.post(`${API_BASE}/v1/monitoring/check/${vendorId}`),
// };

// export default monitoringApi;

import api from './api';  // Import the configured api client instead of axios

const API_BASE = '/api';

export interface GlobalSchedule {
  tenant_id?: string;
  frequency: string;
  day_of_week: number;
  day_of_month: number;
  interval_days?: number | null;
  time: string;
  is_active: number;
  scan_type?: 'fast' | 'deep';
}

export interface VendorSchedule {
  id: string;
  tenant_id?: string;
  vendor_id: string;
  vendor_name?: string;
  domain?: string;
  score?: number;
  risk_level?: string;
  frequency: string;
  day_of_week: number | null;
  day_of_month: number | null;
  interval_days?: number | null;
  time: string;
  is_active: number;
  last_run: string | null;
  next_run: string | null;
  using_global?: boolean;
  scan_type?: 'fast' | 'deep';
  inherits_default?: boolean;
  is_self?: boolean;
  monitoring_paused?: boolean;
  vendor_status?: string | null;
  last_scan?: string | null;
}

export interface AlertRule {
  id: string;
  name: string;
  type: string;
  vendor_id: string | null;
  threshold_value: number | null;
  threshold_percentage: number | null;
  consecutive_count: number;
  cooldown_minutes: number;
  severity: string;
  is_active: number;
  time_start: string | null;
  time_end: string | null;
  days_of_week: string | null;
  escalation_minutes: number | null;
  escalation_severity: string | null;
  webhook_url: string | null;
}

export interface Alert {
  id: string;
  vendor_id: string;
  vendor_name: string;
  alert_type: string;
  message: string;
  severity: string;
  old_value: string | null;
  new_value: string | null;
  is_read: number;
  created_at: string;
}

export interface DriftSettings {
  score_threshold: number;
  risk_level_drift: number;
  compliance_drop_percentage: number;
  is_active: number;
}

export interface MonitoringStats {
  total_alerts: number;
  unread_alerts: number;
  active_schedules: number;
  active_rules: number;
  active_silences: number;
  severity_breakdown: Record<string, number>;
  daily_trend: Array<{ date: string; count: number }>;
}

const monitoringApi = {
  // Schedule endpoints
  getGlobalSchedule: () => api.get('/v1/monitoring/schedule/global'),
  updateGlobalSchedule: (data: GlobalSchedule) => api.put('/v1/monitoring/schedule/global', data),
  getVendorSchedule: (vendorId: string) => api.get(`/v1/monitoring/schedule/vendor/${vendorId}`),
  createVendorSchedule: (data: any) => api.post('/v1/monitoring/schedule/vendor', data),
  getAllSchedules: () => api.get('/v1/monitoring/schedule/all'),
  bulkUpdateSchedules: (data: any) => api.post('/v1/monitoring/schedule/bulk', data),
  deleteVendorSchedule: (vendorId: string) => api.delete(`/v1/monitoring/schedule/vendor/${vendorId}`),
  getDueScans: () => api.get('/v1/monitoring/schedule/due'),
  getScheduleCalendar: (days = 31) => api.get('/v1/monitoring/schedule/calendar', { params: { days } }),
  previewSchedule: (data: any) => api.post('/v1/monitoring/schedule/preview', data),
  
  // Alert Rules
  getAlertRules: (vendorId?: string) => api.get('/v1/monitoring/alerts/rules', { params: { vendor_id: vendorId } }),
  getAlertRule: (ruleId: string) => api.get(`/v1/monitoring/alerts/rules/${ruleId}`),
  createAlertRule: (data: any) => api.post('/v1/monitoring/alerts/rules', data),
  updateAlertRule: (ruleId: string, data: any) => api.put(`/v1/monitoring/alerts/rules/${ruleId}`, data),
  deleteAlertRule: (ruleId: string) => api.delete(`/v1/monitoring/alerts/rules/${ruleId}`),
  
  // Alert History
  getUnreadAlerts: (vendorId?: string) => api.get('/v1/monitoring/alerts/unread', { params: { vendor_id: vendorId } }),
  getAlertHistory: (vendorId?: string, limit?: number, offset?: number) => 
    api.get('/v1/monitoring/alerts/history', { params: { vendor_id: vendorId, limit, offset } }),
  getAlertStatistics: () => api.get('/v1/monitoring/alerts/statistics'),
  markAlertRead: (alertId: string) => api.post(`/v1/monitoring/alerts/${alertId}/read`),
  bulkMarkRead: (alertIds: string[]) => api.post('/v1/monitoring/alerts/bulk-read', alertIds),
  acknowledgeAlert: (alertId: string, acknowledgedBy: string) => 
    api.post(`/v1/monitoring/alerts/${alertId}/acknowledge`, null, { params: { acknowledged_by: acknowledgedBy } }),
  resolveAlert: (alertId: string, resolutionNote?: string) => 
    api.post(`/v1/monitoring/alerts/${alertId}/resolve`, { resolution_note: resolutionNote }),
  exportAlerts: () => api.get('/v1/monitoring/export/alerts'),
  
  // Indicator Groups
  getIndicatorGroups: () => api.get('/v1/monitoring/indicator-groups'),
  getVendorIndicatorGroups: (vendorId: string) => api.get(`/v1/monitoring/indicator-groups/vendor/${vendorId}`),
  updateVendorIndicatorGroups: (vendorId: string, data: any) => 
    api.put(`/v1/monitoring/indicator-groups/vendor/${vendorId}`, data),
  getAllVendorIndicatorSelections: () => api.get('/v1/monitoring/indicator-groups/all-vendors'),
  bulkUpdateIndicatorGroups: (data: any) => api.post('/v1/monitoring/indicator-groups/bulk', data),
  
  // Alert Silences
  getActiveSilences: (vendorId?: string, ruleId?: string) => 
    api.get('/v1/monitoring/silences', { params: { vendor_id: vendorId, rule_id: ruleId } }),
  createAlertSilence: (data: any) => api.post('/v1/monitoring/silences', data),
  deactivateSilence: (silenceId: string) => api.delete(`/v1/monitoring/silences/${silenceId}`),
  
  // Notification Channels
  getNotificationChannels: () => api.get('/v1/monitoring/channels'),
  createNotificationChannel: (data: any) => api.post('/v1/monitoring/channels', data),
  updateNotificationChannel: (channelId: string, config: any) => 
    api.put(`/v1/monitoring/channels/${channelId}`, config),
  deleteNotificationChannel: (channelId: string) => api.delete(`/v1/monitoring/channels/${channelId}`),
  addRuleChannelMapping: (ruleId: string, data: any) => 
    api.post(`/v1/monitoring/rules/${ruleId}/channels`, data),
  getRuleChannels: (ruleId: string) => api.get(`/v1/monitoring/rules/${ruleId}/channels`),
  
  // Drift Settings
  getDriftSettings: (vendorId: string) => api.get(`/v1/monitoring/drift/${vendorId}`),
  updateDriftSettings: (vendorId: string, data: DriftSettings) => 
    api.put(`/v1/monitoring/drift/${vendorId}`, data),
  
  // Monitoring Stats
  getMonitoringStats: () => api.get('/v1/monitoring/stats'),
  
  // Manual Check
  triggerManualCheck: (vendorId: string) => api.post(`/v1/monitoring/check/${vendorId}`),
};

export default monitoringApi;